module.exports = __webpack_public_path__ + "static/media/ClipBoard.bf77cb4d.svg";